<template>
  <h2 class="text-lg font-medium hidden lg:block">
    {{ trans.get('miliboo.filters.categories') }}
  </h2>
  <ul class="flex flex-wrap lg:block gap-2 lg:space-y-2 text-sm">
    <template v-if="categories.length">
      <li
        v-for="category in categories"
        :key="category.id"
      >
        <SuggestCategoryListItem
          :slug="category.list_filter.at(0).list.slug"
          :label="category.name"
        />
      </li>
    </template>
    <template v-else>
      <SuggestCategoryListEmpty :menu="menu" />
    </template>
  </ul>
</template>
<script setup>
import { computed, inject } from 'vue';
import SuggestCategoryListItem from './SuggestCategoryListItem.vue';
import SuggestCategoryListEmpty from './SuggestCategoryListEmpty.vue';

const props = defineProps({
  products: {
    type: Array,
    required: true,
  },
  menu: {
    type: Object,
    required: true,
  },
});

const trans = inject('translate');

const categories = computed(() => [
  ...new Map(props.products
    .filter((product) => product.category.list_filter.length)
    .map((product) => [product.category.id, product.category]))
    .values(),
].sort((a, b) => a.id - b.id));

</script>
